import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {PaymentCardDto} from "../../../../models/payment-card-dto";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-successful-payment',
  templateUrl: './successful-payment.component.html',
  styleUrls: ['./successful-payment.component.scss'],
  standalone: false
})
export class SuccessfulPaymentComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Subscription Pricing'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageName = 'Successful Payment';

  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Successful Payment");
  }

  ngOnInit() {
    this.pageErrorMessages = [];
    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.userService.setUserDefaultPayment(this.username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.pageSuccessMessages.push({
              field: 'Consultant Referral Code Error',
              detail: 'Consultant Referral Code failed to verify.',
              severity: 'error'
            });
          this.showSuccessMessagesToUser();
        }
      },(error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
            field: 'Consultant Referral Code Error',
            detail: 'Consultant Referral Code failed to verify.',
            severity: 'error'
          });
        this.showPageErrorMessagesToUser();
      }
    );
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    setTimeout(counterFn, 10000);
  }

  onGoToDashboard(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
